import { ArrowUpRight, BadgeCheck, Star } from "lucide-react";
import { CONTACT } from "./data";
import { Photo } from "./Photo";

const Status = ({ children }) => (
  <div className="flex min-w-0 flex-col items-center gap-2 text-center text-paper">
    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-paper text-moss">
      <BadgeCheck size={14} strokeWidth={2} aria-hidden="true" />
    </span>
    <span className="max-w-full break-words text-[0.68rem] font-semibold leading-tight sm:text-sm">{children}</span>
  </div>
);

export const SocialProof = () => (
  <section aria-labelledby="omdome-title" className="py-20 md:py-28" data-testid="social-proof-section">
    <div className="container-site">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
        <div className="reveal min-w-0 w-full justify-self-center lg:col-span-5 lg:justify-self-auto">
          <div className="relative mx-auto min-h-[560px] w-full max-w-[680px] overflow-hidden rounded-[28px] bg-[#8A8E91] shadow-[0_24px_70px_rgba(31,36,40,0.14)] lg:mx-0 lg:max-w-none">
            <Photo
              name="projekt-rott-hus"
              alt=""
              sizes="(min-width: 1024px) 40vw, 100vw"
              position="50% 50%"
              className="absolute inset-0 opacity-35 grayscale"
            />
            <div className="absolute inset-0 bg-[#777C80]/75" aria-hidden="true" />

            <div className="relative z-10 flex min-h-[560px] flex-col items-center px-7 py-10 sm:px-10 sm:py-12">
              <p className="self-start text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-paper/80">Omdömen</p>

              <div className="mt-7 flex h-28 w-28 items-center justify-center rounded-full bg-paper shadow-[0_10px_28px_rgba(0,0,0,0.10)] sm:h-32 sm:w-32">
                <img src="/images/folkare-logo.webp" alt="Folkare Bygg" className="w-[82%] max-w-[92px]" />
              </div>

              <h2 id="omdome-title" className="mt-8 text-center font-sans text-2xl font-bold text-paper sm:text-3xl">
                Folkare Bygg
              </h2>

              <div className="mt-7 grid w-full min-w-0 grid-cols-3 items-start gap-2 sm:gap-4">
                <Status>F-skatt</Status>

                <div className="min-w-0 text-center">
                  <div className="flex min-w-0 justify-center gap-0.5 text-[#F1C40F] sm:gap-1" aria-label="5 av 5 stjärnor">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} size={25} strokeWidth={1.3} fill="currentColor" className="h-5 w-5 shrink-0 sm:h-[25px] sm:w-[25px]" aria-hidden="true" />
                    ))}
                  </div>
                  <p className="mt-2 text-sm font-semibold text-paper">5/5</p>
                </div>

                <div className="flex min-w-0 flex-col items-center gap-2 text-center text-paper">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-paper text-moss">
                    <BadgeCheck size={14} strokeWidth={2} aria-hidden="true" />
                  </span>
                  <span className="whitespace-nowrap text-[0.61rem] font-semibold leading-tight sm:text-sm">
                    Momsregistrerad
                  </span>
                </div>
              </div>

              <a
                href={CONTACT.dorunner}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto inline-flex w-full items-center justify-center gap-3 rounded-full bg-paper px-7 py-4 text-sm font-bold text-ink transition-transform duration-200 hover:-translate-y-0.5"
                data-testid="dorunner-link"
              >
                Läs omdömena
                <ArrowUpRight size={17} strokeWidth={1.8} aria-hidden="true" />
                <span className="sr-only">(öppnas i ny flik)</span>
              </a>
            </div>
          </div>
        </div>

        <div className="reveal lg:col-span-6 lg:col-start-7">
          <p className="eyebrow">Tryggt val för ditt projekt</p>
          <h3 className="mt-5 max-w-2xl font-display text-4xl leading-[1.03] text-ink sm:text-5xl lg:text-[3.8rem]">
            5/5 i kundbetyg. <span className="italic text-moss">Och ordning på det praktiska.</span>
          </h3>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-ink2 sm:text-[1.06rem]">
            Folkare Bygg har 5 av 5 i kundbetyg och arbetar med F-skatt, momsregistrering och ansvarsförsäkring.
            Det ger en tryggare grund när du anlitar hjälp för renovering, tillbyggnad eller andra byggprojekt.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {["F-skatt", "Ansvarsförsäkring", "Momsregistrerad"].map((item) => (
              <span key={item} className="inline-flex items-center gap-2 rounded-full border border-line bg-paper px-4 py-2 text-sm font-semibold text-ink">
                <BadgeCheck size={16} strokeWidth={1.8} className="text-moss" aria-hidden="true" />
                {item}
              </span>
            ))}
          </div>

          <p className="mt-9 font-display text-2xl italic leading-snug text-moss" data-testid="dorunner-rating">
            Fem stjärnor. Samma personliga kontakt genom hela jobbet.
          </p>
        </div>
      </div>
    </div>
  </section>
);
